// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-tabs {
  display: flex;
  border-bottom: 1px solid #ccc;
}

.tab-step {
  position: relative;
  padding: 10px 20px;
  background-color: #f2f2f2;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  margin-right: 2px;
}

.tab-step.active {
  background-color: #007bff;
  color: #fff;
}

.tab-step.active::after {
  content: "";
  position: absolute;
  right: -10px;
  top: 0;
  width: 0;
  height: 0;
  border-top: 21px solid transparent;
  border-bottom: 21px solid transparent;
  border-left: 10px solid #007bff;
  -webkit-clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%);
  clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%);
  z-index: 1;
}

.tab-step {
  z-index: 1;
}

.tab-step.active {
  z-index: 2;
}

.tab-step.active::after {
  z-index: 3;
  background: #007bff;
}`, "",{"version":3,"sources":["webpack://./src/app/compensation/evaluation-tracking/evaluation-tracking.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EAEA,iBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,WAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,+BAAA;EACA,8FAAA;EACA,sFAAA;EACA,UAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,UAAA;EACA,mBAAA;AAAF","sourcesContent":[".custom-tabs {\n  display: flex;\n  border-bottom: 1px solid #ccc;\n}\n\n.tab-step {\n  position: relative;\n  padding: 10px 20px;\n  background-color: #f2f2f2;\n  color: #333;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s;\n  //   clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%);\n  margin-right: 2px;\n}\n\n.tab-step.active {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.tab-step.active::after {\n  content: '';\n  position: absolute;\n  right: -10px;\n  top: 0;\n  width: 0;\n  height: 0;\n  border-top: 21px solid transparent;\n  border-bottom: 21px solid transparent;\n  border-left: 10px solid #007bff;\n  -webkit-clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%);\n  clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%);\n  z-index: 1;\n}\n\n.tab-step {\n  z-index: 1;\n}\n\n.tab-step.active {\n  z-index: 2;\n}\n\n.tab-step.active::after {\n  z-index: 3;\n  background: #007bff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
